import type { CartLine, OrderItem } from "@/types/domain";
import { lineRequiresBackOrder } from "./orderAvailability.ts";
import { unitPriceForMixing } from "./orderMixing.ts";

export interface AddOptions {
  unitPrice?: number;
  location?: string;
  availableAtLocation?: number;
  isBackOrder?: boolean;
  mixInstructions?: string;
  overrideReason?: string;
}

export function addCartLine(
  item: OrderItem,
  quantity: number,
  options: AddOptions = {},
  existing?: CartLine,
): CartLine {
  const baseUnitPrice =
    options.unitPrice ?? existing?.baseUnitPrice ?? item.unit_price ?? 0;
  const requiresMixing = existing?.requiresMixing ?? false;
  const line: CartLine = {
    ...item,
    qty: (existing?.qty || 0) + quantity,
    unitPrice: unitPriceForMixing(item, baseUnitPrice, requiresMixing),
    baseUnitPrice,
    location: options.location || existing?.location,
    availableAtLocation:
      options.availableAtLocation ?? existing?.availableAtLocation,
    isBackOrder: options.isBackOrder ?? existing?.isBackOrder,
    mixInstructions: options.mixInstructions || existing?.mixInstructions,
    overrideReason: options.overrideReason || existing?.overrideReason,
    requiresMixing,
  };
  if (line.availableAtLocation !== undefined) {
    line.isBackOrder = lineRequiresBackOrder(line, line.availableAtLocation);
  }
  return line;
}
